module.exports = __webpack_public_path__ + "static/media/cq_flag.dae9fc5b.svg";